@if (reasons?.length) {
  @for (r of reasons; track $index) {
    @switch (r.code) {
      @case ('NoModel') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.NoModel" nzMessage="No inspection model is loaded. Cannot inspect." nzShowIcon></nz-alert>
      }
      @case ('NoImage') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.NoImage" nzMessage="No image was captured for this scan." nzShowIcon></nz-alert>
      }
      @case ('NoMaterial') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.NoMaterial" nzMessage="No material (base) assigned — inspection bypassed." nzShowIcon></nz-alert>
      }
      @case ('ReferenceL') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.ReferenceL" nzMessage="Reference color value is not defined in the catalog. Check the catalog." nzShowIcon></nz-alert>
      }
      @case ('NoRef/Pred') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.NoRefPred" nzMessage="No reference or prediction available — inspection bypassed." nzShowIcon></nz-alert>
      }
      @case ('BL') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.BL" nzMessage="Bucket lightness (BL) is out of range." nzShowIcon></nz-alert>
      }
      @case ('BS') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.BS" nzMessage="There is too much splash on the bucket. Tune the mixer." nzShowIcon></nz-alert>
      }
      @case ('CI') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.CI" nzMessage="Confidence index (CI) is too high — prediction is unreliable." nzShowIcon></nz-alert>
      }
      @case ('dE-CI') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dECI" nzMessage="The color is too rare — dE-CI is below threshold. Bypassed." nzShowIcon></nz-alert>
      }
      @case ('dL') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dL" nzMessage="Lightness delta (dL) exceeded threshold." nzShowIcon></nz-alert>
      }
      @case ('dA') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dA" nzMessage="Green-red delta (dA) exceeded threshold." nzShowIcon></nz-alert>
      }
      @case ('dB') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dB" nzMessage="Blue-yellow delta (dB) exceeded threshold." nzShowIcon></nz-alert>
      }
      @case ('dC') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dC" nzMessage="Color error — different tone (dC)." nzShowIcon></nz-alert>
      }
      @case ('dE') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.dE" nzMessage="Color error — different tone or lightness (dE)." nzShowIcon></nz-alert>
      }
      @case ('xdE') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.xdE" nzMessage="Cross-scan color difference (xdE) versus scan #{{r.scanRef}} is {{r.value | number : '1.2-2'}}. Compare the buckets." nzShowIcon></nz-alert>
      }
      @case ('xdBL') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.xdBL" nzMessage="The bucket plastic color is too different (xdBL={{r.value | number : '1.2-2'}}) versus scan #{{r.scanRef}}. Check the bucket material." nzShowIcon></nz-alert>
      }
      @case ('xdL') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.xdL" nzMessage="Cross-scan lightness difference (xdL={{r.value | number : '1.2-2'}}) versus scan #{{r.scanRef}}." nzShowIcon></nz-alert>
      }
      @case ('xdA') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.xdA" nzMessage="Cross-scan green-red difference (xdA={{r.value | number : '1.2-2'}}) versus scan #{{r.scanRef}}." nzShowIcon></nz-alert>
      }
      @case ('xdB') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.xdB" nzMessage="Cross-scan blue-yellow difference (xdB={{r.value | number : '1.2-2'}}) versus scan #{{r.scanRef}}." nzShowIcon></nz-alert>
      }
      @case ('MlError') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.MlError" nzMessage="ML inference error: {{r.detail ?? 'unknown'}}" nzShowIcon></nz-alert>
      }
      @case ('Stain') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.Stain" nzMessage="Stain detected — colorant not mixed (Stain)." nzShowIcon></nz-alert>
      }
      @case ('StainCheckError') {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.StainCheckError" nzMessage="Stain check failed — bucket not found (StainCheckError)." nzShowIcon></nz-alert>
      }
      @default {
        <nz-alert [nzType]="nzType(r.severity)" i18n-nzMessage="@@failureReason.generic" nzMessage="Inspection did not pass (reason: {{r.code}})." nzShowIcon></nz-alert>
      }
    }
  }
}
